import { defineAction } from '~/prix'
import { z } from 'zod'
import trainingCreateAction from './trainingCreate.action.json' with { type: 'json' }
import { trainingObject } from '../trainingObject'

const trainingCreateDefinition = defineAction({
  ...trainingCreateAction,

  input: trainingObject
    .pick({
      id: true,
      type: true,
      title: true,
      observation: true,
    })
    .partial({ id: true }),
  output: z.object({ id: trainingObject.shape.id }),
})

export default trainingCreateDefinition
